import { Row, Col } from "antd";

export default function ErrorUpdateParcel() {
    return <Row justify="center">
        <Col>
            Δεν υπάρχει ανοιχτό κιβώτιο
        </Col>
    </Row>
}